export default __webpack_public_path__ + "static/media/border-top_pc@2x.966ca69d.png";